import React, { Component } from 'react';
import SubmitButton from '../_shared/SubmitButton';
import axios from 'axios';
import FormError from '../_shared/forms/FormError';
import FormTextInput from '../_shared/forms/FormInputNumber';
import { snakeCaseToTitle } from '../../utils/Helpers';
import ReactDOM from 'react-dom';

export default class TestingLogin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            loggedInAs: '',
            errors: {},
        };
    }

    componentDidMount() {
        this.setState({ loggedInAs: localStorage.getItem('testing_app_user') });
    }

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({
            loading: false,
        });

        if (this.validateForm()) {
            this.setState({
                loading: true,
            });

            var data = new FormData();
            data.append('email', this.state.username);
            data.append('password', this.state.password);
            axios({
                url: this.props.url,
                method: 'POST',
                data: data,
                headers: { 'Content-Type': 'multipart/form-data' },
            })
                .then((response) => {
                    toastr.success('Logged in successfully');

                    localStorage.setItem('testing_app_token', response.data.access_token);
                    localStorage.setItem('testing_app_user', response.data.user.name);
                    this.setState({
                        loading: false,
                        loggedInAs: response.data.user.name,
                    });
                })
                .catch((error) => {
                    toastr.error('Failed to log in');

                    this.setState({
                        loading: false,
                    });
                });
        }
    };

    validateForm = () => {
        let errors = {};
        const fields = ['username', 'password'];

        fields.map((field) => {
            if (!this.state[field]) {
                errors[field] = `${snakeCaseToTitle(field).replace('id', '')} field is required`;
            }
        });

        this.setState({ errors: errors });

        if (Object.keys(errors).length > 0) {
            toastr.error('Please fill in all required fields');
        }

        return Object.keys(errors).length === 0;
    };

    render() {
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <h4 className="text-center">Log in with an app user</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 form-group">
                        <FormTextInput
                            classes="form-control"
                            label="Username"
                            handleChange={(e) => this.setState({ username: e.target.value })}
                        />
                        <FormError error={this.state.errors.username} />
                    </div>
                    <div className="col-md-4 form-group">
                        <FormTextInput
                            classes="form-control"
                            label="Password"
                            type="password"
                            handleChange={(e) => this.setState({ password: e.target.value })}
                        />
                        <FormError error={this.state.errors.password} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 form-group">
                        <SubmitButton buttonText={'Log in'} loading={this.state.loading} style={{ width: 200 }} />
                    </div>
                    <div className="col-md-8 form-group">
                        {this.state.loggedInAs && (
                            <p className="text-info">
                                {'\u24d8'} Last logged in as {this.state.loggedInAs}
                            </p>
                        )}
                    </div>
                </div>
            </form>
        );
    }
}

if (document.getElementById('testing-form-login')) {
    let element = document.getElementById('testing-form-login');
    ReactDOM.render(<TestingLogin url={element.dataset.url} />, element);
}
